import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import { bookingMiddlewares } from "~/store/middlewares/bookingMiddlewares";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(Object.values(bookingMiddlewares))
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
